import styled from 'styled-components'
import { css, media, colors, Link } from 'styles'

const StyledUserThumbHorizontal = styled(Link)`
  margin-right: 2rem;
  color: ${p => (p.inverted ? colors.mainInverted : colors.textMain)};
  display: flex;
  text-decoration: none;
  width: 100%;
  max-width: 21rem;

  .user-info {
    margin-left: 1rem;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
  }

  ${p =>
    p.inverted &&
    css`
      .user-info {
        opacity: 0.8;
      }
      &:hover .user-info {
        opacity: 1;
      }
    `};

  .username,
  .location {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .username {
    margin: 0;
    font-size: 1.6rem;
    font-weight: 600;
  }

  .location {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 300;
    text-transform: capitalize;
    width: 100%;
    opacity: 0.8;
  }

  &:hover {
    .username {
      color: ${p => !p.inverted && p.theme.colors.highlight};
    }
    .location {
      opacity: 1;
    }
  }
  /* Placeholder */
  .username:empty,
  .location:empty {
    height: 1.5rem;
    background-color: #d6d6d6;
    color: transparent;
    opacity: 0.3;
  }
  .username:empty {
    width: 100%;
  }
  .city:empty {
    width: 80%;
  }
  .country:empty {
    width: 55%;
  }

  ${media.mobile`
    .avatar-img {
      width: 10rem;
      height: 10rem;
    }
    .username {
      font-size: 2.2rem;
    }
    .location {
      font-size: 2rem;
    }
  `}
`

export default StyledUserThumbHorizontal
